import React from 'react'
import PropTypes from 'prop-types'
import { Link } from '../general/util/Links'
import './ShowAll.scss'
export const ShowAll = ({ url, inline, linkText }) => {
  return <Link to={{ link: url }} styleName={inline ? 'with-icon inline' : 'with-icon'}>{linkText || 'Näytä kaikki'}</Link>
}

ShowAll.propTypes = {
  url: PropTypes.string,
  inline: PropTypes.bool,
  linkText: PropTypes.string,
}
